import './App.css';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import Terms from './page/terms';
import Disclaimer from './page/disclaimer';
import PrivacyPolicy from './page/policy';
import DataUsage from './page/data';
import FAQ from './page/faq';

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/terms">
            <Link to="/terms" />
            <Terms />
          </Route>
        </Switch>
        <Switch>
          <Route path="/data-usage">
            <DataUsage />
          </Route>
        </Switch>
        <Switch>
          <Route path="/disclaimer">
            <Disclaimer />
          </Route>
        </Switch>
        <Switch>
          <Route path="/privacy-policy">
            <PrivacyPolicy />
          </Route>
        </Switch>
        <Switch>
          <Route path="/faq">
            <FAQ />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
